// extracted by mini-css-extract-plugin
export default {"productDescription":"u_-z","featuredDescription":"v_-z","description":"w_-z","more":"x_-z","descriptionSku":"y_-z"};